import durationToStr from '@/libs/utils/durationToStr'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import ListItem from '@mui/material/ListItem'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'
import LinearProgress from './LinearProgress'
import ThumbUpAlt from '@mui/icons-material/ThumbUpAlt'

const TrainingListItem = ({ data, onClick }) => {
  const { t } = useTranslation()

  const { courseName, courseDesc, coverImage, courseLength, finishedPercent, goodRatingCnt } =
    data || {}

  return (
    <ListItem sx={{ padding: 2 }}>
      <Grid
        container
        spacing={2}
        sx={{
          minHeight: 150,
          boxShadow: '0px 3px 4px -1px rgba(0, 0, 0, .25)',
          pb: 2,
          pr: 2,
        }}
      >
        <Grid item xs={12} md={10} sx={{ color: theme => theme.palette.other.grey[60].main }}>
          <Grid container>
            <Grid item xs={12} sm={4}>
              <Box
                sx={{ maxHeight: { sx: 118 }, maxWidth: '90%' }}
                component="img"
                src={coverImage}
              />
            </Grid>
            <Grid item container xs={12} sm={8} spacing={1}>
              <Grid item>
                <Box display="flex">
                  <Typography color="black">{courseName}</Typography>
                  <Typography sx={{ ml: 3 }}>{`${t('general.course_duration')} ${durationToStr(
                    courseLength,
                  )}`}</Typography>
                  <Typography color="black" sx={{ display: 'flex', alignItems: 'center', ml: 1 }}>
                    {t('general.good_rating_count')}
                    <ThumbUpAlt color="primary" sx={{ mx: 1 }} />
                    {goodRatingCnt}
                  </Typography>
                </Box>
              </Grid>

              <Grid item>
                <Typography>{`${t('general.course_desc')}: ${courseDesc}`}</Typography>
              </Grid>

              <Grid item>
                <Typography>{t('course.notice')}</Typography>
              </Grid>

              <Grid item xs={12}>
                <Box display="flex" alignItems="center">
                  <Typography>{`${t('general.completion_rate')}: ${finishedPercent}%`}</Typography>
                  <LinearProgress
                    sx={{ ml: 2, flex: 1 }}
                    value={finishedPercent}
                    completed={finishedPercent === 100}
                  />
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={2} display="flex" alignItems="center" justifyContent="center">
          <Button
            variant="contained"
            color="secondary_30"
            sx={{ borderRadius: 4 }}
            onClick={onClick}
          >
            {t('general.click_more')}
          </Button>
        </Grid>
      </Grid>
    </ListItem>
  )
}

export default TrainingListItem
